export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Export transaction counts by hour for different order types as CSV.
 *
 * @param {Object[]} transactions            - Array of transaction objects
 * @param {string}   selectedStoreCode       - Store code or 'All Stores'
 * @param {string}   selectedDate            - Date string for the report
 * @param {string}   [fileName='TotalTransactions.csv']
 */
export function exportTransactionTypesByHourCSV(
  transactions,
  storess,
  selectedDate,
  transactionCounts,
  chartData,
  fileName = "TotalTransactions.csv"
) {
  // 1) tally counts per hour for each transaction type
  const counts = transactionCounts;

  // 2) assume chartData.labels are hours 5:00 to 4:00 next day
  //   const chartData = chartData;
  const rows = chartData?.labels.map((day, index) => {
    return {
      Brand: "Angels Pizza", // Replace with actual brand logic
      Store: storess || "All Stores",
      Date: selectedDate, // Or the date that corresponds to the 'day'
      DineIn: transactionCounts.DineIn[index],
      GrabFood: transactionCounts.GrabFood[index],
      TakeOut: transactionCounts.TakeOut[index],
      Delivery: transactionCounts.Delivery[index],
      Drive: transactionCounts.Drive[index],
      FoodPanda: transactionCounts.FoodPanda[index],
    };
  });

  // 3) convert to CSV and trigger download
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportTransactionTypesByHourCSV: no data to export");
    return;
  }

  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
